export default __webpack_public_path__ + "static/media/590.44ea5652.gif";